import React, { useState, useEffect } from 'react';
import { Box, Grid, TextField, Typography } from '@mui/material';
import koLocale from 'date-fns/locale/ko';
import DateAdapter from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DatePicker from '@mui/lab/DatePicker';
import NumberFormatCustom from '../../common/form/NumberFormatCustom';

const EstimateForm = ({ chance, estimate, formik }) => {
  const [qteRegDt, setQteRegDt] = useState(null);
  const [qteValidDt, setQteValidDt] = useState(null);

  useEffect(() => {
    if (formik.values?.qteRegDt) {
      setQteRegDt(formik.values?.qteRegDt);
    }
    if (formik.values?.qteValidDt) {
      setQteValidDt(formik.values?.qteValidDt);
    }
  }, []);

  useEffect(() => {
    if (estimate) {
      if (estimate?.qteRegDt) setQteRegDt(estimate?.qteRegDt);
      if (estimate?.qteValidDt) setQteValidDt(estimate?.qteValidDt);
    }
  }, [estimate]);

  const onChangeDate = (newValue, name) => {
    formik.setFieldValue(name, newValue);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={4}>
          <Typography variant="body2" component="div" textAlign="center">
            매출 타입 - {chance?.prjTyp === 'N' ? `프로젝트` : chance?.prjTyp === 'ETC' ? `기타매출` : `유지보수`}
          </Typography>
        </Grid>
        <Grid item xs={4}>
          <TextField
            margin="normal"
            required
            disabled
            variant="outlined"
            fullWidth
            id="qtePrice"
            name="qtePrice"
            label="총 견적금액"
            value={formik.values.qtePrice}
            // onChange={(e) => formik.setFieldValue('qtePrice', e.target.value)}
            // error={formik.touched.qtePrice && Boolean(formik.errors.qtePrice)}
            // helperText={formik.touched.qtePrice && formik.errors.qtePrice}
            InputProps={{
              inputComponent: NumberFormatCustom,
            }}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={4}>
          <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
            <DatePicker
              label="견적일자"
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              id="qteRegDt"
              name="qteRegDt"
              value={qteRegDt}
              onChange={(newValue) => {
                setQteRegDt(newValue);
                onChangeDate(newValue, 'qteRegDt');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  required={false}
                  fullWidth
                  error={
                    formik.touched.qteRegDt && Boolean(formik.errors.qteRegDt)
                  }
                  helperText={formik.touched.qteRegDt && formik.errors.qteRegDt}
                />
              )}
            />
          </LocalizationProvider>
        </Grid>
        <Grid item xs={4}>
          <LocalizationProvider dateAdapter={DateAdapter} locale={koLocale}>
            <DatePicker
              label="견적 유효일자"
              inputFormat={'yyyy-MM-dd'}
              mask={'____-__-__'}
              id="qteValidDt"
              name="qteValidDt"
              value={qteValidDt}
              onChange={(newValue) => {
                setQteValidDt(newValue);
                onChangeDate(newValue, 'qteValidDt');
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  margin="normal"
                  variant="outlined"
                  required={false}
                  fullWidth
                  error={
                    formik.touched.qteValidDt &&
                    Boolean(formik.errors.qteValidDt)
                  }
                  helperText={
                    formik.touched.qteValidDt && formik.errors.qteValidDt
                  }
                />
              )}
            />
          </LocalizationProvider>
        </Grid>

        <Grid item xs={4}>
          <TextField
            margin="normal"
            variant="outlined"
            fullWidth
            required={false}
            id="mntTor"
            name="mntTor"
            label="유지보수기간(개월)"
            InputLabelProps={{ shrink: true }}
            value={formik.values.mntTor}
            onChange={formik.handleChange}
            error={formik.touched.mntTor && Boolean(formik.errors.mntTor)}
            helperText={formik.touched.mntTor && formik.errors.mntTor}
          />
        </Grid>
      </Grid>

      <Grid
        container
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
        sx={{
          py: 1,
          borderBottom: (theme) => `1px solid ${theme.palette.divider}`,
        }}
      >
        <Grid item xs={4}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            id="qteUsrNm"
            name="qteUsrNm"
            label="담당자명"
            value={formik.values.qteUsrNm}
            onChange={formik.handleChange}
            error={formik.touched.qteUsrNm && Boolean(formik.errors.qteUsrNm)}
            helperText={formik.touched.qteUsrNm && formik.errors.qteUsrNm}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            id="qteUsrTel"
            name="qteUsrTel"
            label="담당자 연락처"
            value={formik.values.qteUsrTel}
            onChange={formik.handleChange}
            error={formik.touched.qteUsrTel && Boolean(formik.errors.qteUsrTel)}
            helperText={formik.touched.qteUsrTel && formik.errors.qteUsrTel}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            margin="normal"
            required
            variant="outlined"
            fullWidth
            id="qteUsrEml"
            name="qteUsrEml"
            label="담당자 이메일"
            value={formik.values.qteUsrEml}
            onChange={formik.handleChange}
            error={formik.touched.qteUsrEml && Boolean(formik.errors.qteUsrEml)}
            helperText={formik.touched.qteUsrEml && formik.errors.qteUsrEml}
          />
        </Grid>
      </Grid>

      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            variant="outlined"
            fullWidth
            required
            id="destPlace"
            name="destPlace"
            label="납품 장소"
            InputLabelProps={{ shrink: true }}
            value={formik.values.destPlace}
            onChange={formik.handleChange}
            error={formik.touched.destPlace && Boolean(formik.errors.destPlace)}
            helperText={formik.touched.destPlace && formik.errors.destPlace}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            variant="outlined"
            fullWidth
            required
            id="qteCondt"
            name="qteCondt"
            label="발행 조건"
            InputLabelProps={{ shrink: true }}
            value={formik.values.qteCondt}
            onChange={formik.handleChange}
            error={formik.touched.qteCondt && Boolean(formik.errors.qteCondt)}
            helperText={formik.touched.qteCondt && formik.errors.qteCondt}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            variant="outlined"
            required
            fullWidth
            id="payCond"
            name="payCond"
            label="결제 조건"
            InputLabelProps={{ shrink: true }}
            value={formik.values.payCond}
            onChange={formik.handleChange}
            error={formik.touched.payCond && Boolean(formik.errors.payCond)}
            helperText={formik.touched.payCond && formik.errors.payCond}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            variant="outlined"
            required
            fullWidth
            id="qteDesc1"
            name="qteDesc1"
            label="견적서 설명 1"
            //InputLabelProps={{ shrink: true }}
            value={formik.values.qteDesc1}
            onChange={formik.handleChange}
            error={formik.touched.qteDesc1 && Boolean(formik.errors.qteDesc1)}
            helperText={formik.touched.qteDesc1 && formik.errors.qteDesc1}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            variant="outlined"
            fullWidth
            id="qteDesc2"
            name="qteDesc2"
            label="견적서 설명 2"
            //InputLabelProps={{ shrink: true }}
            value={formik.values.qteDesc2}
            onChange={formik.handleChange}
            error={formik.touched.qteDesc2 && Boolean(formik.errors.qteDesc2)}
            helperText={formik.touched.qteDesc2 && formik.errors.qteDesc2}
          />
        </Grid>
      </Grid>
      <Grid
        container
        direction="row"
        justifyContent="flex-start"
        alignItems="center"
        spacing={1}
      >
        <Grid item xs={12}>
          <TextField
            margin="normal"
            variant="outlined"
            fullWidth
            id="qteDesc3"
            name="qteDesc3"
            label="견적서 설명 3"
            //InputLabelProps={{ shrink: true }}
            value={formik.values.qteDesc3}
            onChange={formik.handleChange}
            error={formik.touched.qteDesc3 && Boolean(formik.errors.qteDesc3)}
            helperText={formik.touched.qteDesc3 && formik.errors.qteDesc3}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default EstimateForm;
